import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { POST } from "@/utils/http.js"
Vue.prototype.post = POST;


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
